import { SearchForm } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const containerIsPhoneCss = "c1ww9cgw";
const containerCss = "cfgd7p1";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const searchFormWrapperIsPhoneCss = "s14wd42c";
const searchFormWrapperCss = "ssnvzqj";
const SearchFormWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(searchFormWrapperCss, {
    [searchFormWrapperIsPhoneCss]: isPhone
  }, props.className)} />;
});
export const SearchFilter = ({
  onSearch
}) => <Container>
    <SearchFormWrapper>
      <SearchForm id="event-types-search" placeholder={I18n.t('publisher.contacts.search_placeholder')} onSearch={onSearch} data-calendly-label="search-field" />
    </SearchFormWrapper>
  </Container>;

require("./search_filter.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./search_filter.js");